import { render, staticRenderFns } from "./RegTypeList.vue?vue&type=template&id=9b02fe4c&scoped=true&"
import script from "./RegTypeList.vue?vue&type=script&lang=js&"
export * from "./RegTypeList.vue?vue&type=script&lang=js&"
import style0 from "./RegTypeList.vue?vue&type=style&index=0&id=9b02fe4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b02fe4c",
  null
  
)

export default component.exports